import React from "react";
import { useTranslation } from "react-i18next";
import LocalizedLink from "../LocalizedLink/LocalizedLink";
import erimg from "../../images/error-404.png";

const Error = ({ message }) => {
  const { t } = useTranslation("error");
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="error-404-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col col-xs-12">
            <div className="content clearfix">
              <div className="error">
                {!message && <img src={erimg} alt="" />}
              </div>
              <div className="error-message">
                {message ? (
                  <>
                    <h3>{t("soonTitle")}</h3>
                    <p>{t("soonText")}</p>
                  </>
                ) : (
                  <>
                    <h3>{t("notFoundTitle")}</h3>
                    <p>{t("notFoundText")}</p>
                  </>
                )}
                <LocalizedLink onClick={ClickHandler} to="/home" className="theme-btn">
                  {t("backHome")}
                </LocalizedLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Error;
